import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=67e147ee&scoped=true&"
import script from "./PageResult.vue?vue&type=script&lang=js&"
export * from "./PageResult.vue?vue&type=script&lang=js&"
import style0 from "./PageResult.vue?vue&type=style&index=0&id=67e147ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e147ee",
  null
  
)

export default component.exports